var map = {
	"./aidejiaolianIcon.svg": "./src/components/aiChat/images/svg/aidejiaolianIcon.svg",
	"./arrowRightIcon.svg": "./src/components/aiChat/images/svg/arrowRightIcon.svg",
	"./congxinshengchengIcon.svg": "./src/components/aiChat/images/svg/congxinshengchengIcon.svg",
	"./copyIcon.svg": "./src/components/aiChat/images/svg/copyIcon.svg",
	"./defaultSendIcon.svg": "./src/components/aiChat/images/svg/defaultSendIcon.svg",
	"./dislikeIcon.svg": "./src/components/aiChat/images/svg/dislikeIcon.svg",
	"./fuzhiIcon.svg": "./src/components/aiChat/images/svg/fuzhiIcon.svg",
	"./historyIcon.svg": "./src/components/aiChat/images/svg/historyIcon.svg",
	"./jinghaoIcon.svg": "./src/components/aiChat/images/svg/jinghaoIcon.svg",
	"./likeIcon.svg": "./src/components/aiChat/images/svg/likeIcon.svg",
	"./sendIcon.svg": "./src/components/aiChat/images/svg/sendIcon.svg",
	"./shendusikaoIcon.svg": "./src/components/aiChat/images/svg/shendusikaoIcon.svg",
	"./shouqiIcon.svg": "./src/components/aiChat/images/svg/shouqiIcon.svg",
	"./stopIcon.svg": "./src/components/aiChat/images/svg/stopIcon.svg",
	"./uploadIcon.svg": "./src/components/aiChat/images/svg/uploadIcon.svg",
	"./xiandianIcon.svg": "./src/components/aiChat/images/svg/xiandianIcon.svg",
	"./xiangshangjiantouIcon.svg": "./src/components/aiChat/images/svg/xiangshangjiantouIcon.svg",
	"./xiangyoujiantouIcon.svg": "./src/components/aiChat/images/svg/xiangyoujiantouIcon.svg",
	"./xiangyoujiantouIcon2.svg": "./src/components/aiChat/images/svg/xiangyoujiantouIcon2.svg",
	"./xinjianduihuaIcon.svg": "./src/components/aiChat/images/svg/xinjianduihuaIcon.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/components/aiChat/images/svg sync recursive ^\\.\\/.*\\.svg$";